import { useEffect } from 'react';

import { getEditor } from '../../../lib/dom/selectors';

// So, this isn't really how I'd like to do this. Unfortunately the TipTap <EditorContent>
// component applies any extra props to the *wrapper* of the input div, not the input div itself.
// This means that to have proper accessibility, with the role="textbox", we need to wait for
// the editor to be rendered, then find the input div and apply the role attribute to it.

// See implementation at https://github.com/ueberdosis/tiptap/blob/develop/packages/react/src/EditorContent.tsx

export const useInputRole = (id: string) => {
	useEffect(() => {
		const el = getEditor(id);

		if (el) {
			return el.setAttribute('role', 'textbox');
		}

		const observer = new MutationObserver(() => {
			const el = getEditor(id);

			if (el) {
				observer.disconnect();
				return el.setAttribute('role', 'textbox');
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		return () => observer.disconnect();
	}, [id]);
};
